export enum FiscalizationState {
    NotApplicable = 'NotApplicable',
    NotFiscalized = 'NotFiscalized',
    Fiscalized = 'Fiscalized',
}
